import lacquers, { lacquerNames } from '@constants/values/lacquers'

const rodzajLakieru = {
    t: 'Rodzaj lakieru',
    type: 'all-checkbox',
    name: 'lakier',
    options: lacquers,
    names: lacquerNames,
}

export default rodzajLakieru